/**
 * Exibe a SITUACAO do contrato como veio da API.
 * Vazio/nulo → "Em dia".
 */
export const normalizeSituacaoKey = (situacao) =>
  String(situacao ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const formatSituacaoContrato = (situacao) => {
  const raw = String(situacao ?? '').trim();
  if (!raw) return 'Em dia';
  return raw;
};

export const isSituacaoEmDia = (situacao) => {
  const key = normalizeSituacaoKey(situacao);
  if (!key) return true;
  if (key === 'atrasado' || key === 'em atraso') return false;
  return true;
};

const hasSituacaoValue = (value) =>
  value !== undefined && value !== null && String(value).trim() !== '';

/**
 * Resolve a situação bruta a partir do contrato (login/validate-token, depois dashboard).
 * Auth vem primeiro: no F5 o validate-token busca SITUACAO ao vivo, enquanto o
 * dashboard pode estar em cache (até 10 min no backend).
 * Não usa statusFinanceiro (EM DIA/EM ATRASO) — só SITUACAO.
 */
export const resolveSituacaoRaw = (contrato, fallbackContrato, contratosLista = []) => {
  const numero = contrato?.numero ?? fallbackContrato?.numero;
  const fromLista = Array.isArray(contratosLista)
    ? contratosLista.find((c) => String(c?.numero) === String(numero))
    : null;

  const sources = [
    fromLista?.situacao,
    fromLista?.SITUACAO,
    fallbackContrato?.situacao,
    fallbackContrato?.SITUACAO,
    contrato?.situacao,
    contrato?.SITUACAO,
  ];

  for (const value of sources) {
    if (hasSituacaoValue(value)) {
      return String(value).trim();
    }
  }

  return '';
};
